
// Edit Section A : Add field from FormField boiler plate library

import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardFormHorizontalThird } from '../../widgets/Cards';


import { editHAExam, newHAExam, fetchHAExams } from '../../../actions';

class HAExam extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchHAExams(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchHAExams(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].healthassessment;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }

    HAExamForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;
            
            form['patientId'] = this.props.patient._id;
            form['userId'] = this.props.userId;
            this.props.newHAExam(form);
        }

        const required = value =>(value ? undefined : 'Required');

    

// SECTION A
        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Examination</div>

                            <div className='form-4-columns'>
                                <div>
                                <Field name='heart' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Cardiovascular</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='lung' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Respiratory</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='acutepain' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Acute Pain</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='chronicpain' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Chronic Pain</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='adl' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Activity of Daily Living</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='iadl' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>instrument Activity of Daily Living</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='mental' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Mental health</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='memory' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Memory</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='oral' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Oral health</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='nutrition' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Nutrition</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='diet' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Diet</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='skin' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Skin integrity</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='mobility' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Mobility</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='hearing' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Hearing</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='vision' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Vision</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='urine' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Urination</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='bowel' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Bowel movement</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='muscle' component='input'  placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Muscle Tone</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='nail' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Nails</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='aid' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Mobility aid</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='drive' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Driving</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='fall' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Recent Fall</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='tool' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Tools</label>
                                            <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='result' component='input' placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Summary</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                            </div>

                            <div className={this.formButton()} >
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button type='button' onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardFormHorizontalThird content={this.HAExamForm()}>
            </CardFormHorizontalThird>
        )
    }
}


const mapStateToProps = (state) => {

    return { 
             patient : state.selectedPatient,
             content : Object.values(state.ha_exams),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editHAExam, newHAExam, fetchHAExams})(HAExam);
